var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.MenuObj = new Class({
    Implements: [Options, Events],
    element: null,
    ul_element: null,
    ul_trans: null,
    active: false,
    options: {
        container: null,
        menu_class_name: "",
        element_class_name: ""
    },
    bound_methods: {},
    initialize: function (element, ops) {
        this.setOptions(ops);
        this.bound_methods.activate = this.on_activate.bind(this);
        this.bound_methods.deactivate = this.on_deactivate.bind(this);
        this.bound_methods.toggle = this.toggle.bind(this);
        if (element) {
            var self = element.retrieve('menu_obj');
            if (self) {
                return self;
            }
            this.element = element;
            this.element.addClass(this.options.element_class_name);
            this.ul_element = this.element.getElement('ul');
            if (this.ul_element) {
                this.ul_element.addClass(this.options.menu_class_name);
                this.ul_element.getChildren('li').each(function (li) {
                    this.get_menu_element_obj(li);
                }.bind(this));
                this.ul_trans = new Fx.Morph(this.ul_element, {
                    duration: 1200,
                    transition: Fx.Transitions.Sine.easeInOut,
                    link: 'chain',
                    unit: '%'
                });
            }

            this.add_events();
            this.element.store('menu_obj', this);
        }
    },
    get_menu_element_obj: function () {

    },
    add_events: function () {
        if (!OCS.device.mobile) {
            this.element.hoverIntent({
                over: this.bound_methods.activate,
                //out: this.bound_methods.deactivate
            });
        } else {
            this.element.addEvent('click', this.bound_methods.toggle);
        }

    },
    on_activate: function (e) {
        if (!this.active) {
            this.activate(e);
        }
    },
    on_deactivate: function (e) {
        if (this.active) {
            this.deactivate(e);
        }
    },
    toggle: function (event) {
        event.stop();
        if (this.active) {
            this.deactivate();
        } else {
            this.activate();
        }
        return this;
    },
    activate: function () {
        this.active = true;
        this.element.addClass('active');
        return this;
    },
    deactivate: function () {
        this.active = false;
        this.element.removeClass('active');
        return this;
    },
    destroy: function () {
        if (this.element) {
            this.element.store('menu_obj', null);
            this.element.removeEvents();
            this.element.destroy();
            this.element = null;
        }
        this.removeEvents();
        this.options = {};
    }
});